import { Schema } from '../queries';
import { SchemaFormArray } from './schema-form-array';
import { SchemaFormBoolean } from './schema-form-boolean';
import { SchemaFormInteger } from './schema-form-integer';
import { SchemaFormNumber } from './schema-form-number';
import { SchemaFormObject } from './schema-form-object';
import { SchemaFormString } from './schema-form-string';

interface Props {
  schemaId: string;
  schema: Schema;
  path?: string;
}

const SchemaFormMap = {
  string: SchemaFormString,
  number: SchemaFormNumber,
  array: SchemaFormArray,
  object: SchemaFormObject,
  integer: SchemaFormInteger,
  boolean: SchemaFormBoolean,
};

export function SchemaForm({ schema, schemaId, path = '' }: Props) {
  const Component = SchemaFormMap[schema.type];
  return <Component schema={schema} path={path} schemaId={schemaId} />;
}
